import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    backPath?: string;
    actions?: React.ReactNode;
}

export function PageHeader({ title, subtitle, backPath, actions }: PageHeaderProps) {
    const navigate = useNavigate();

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                <div className={styles.left}>
                    {backPath && (
                        <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => navigate(backPath)}
                            className={styles.backButton}
                        >
                            <i className="fa-solid fa-chevron-left"></i>
                        </Button>
                    )}
                    <div className={styles.content}>
                        <h1 className={styles.title}>{title}</h1>
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                </div>
                {actions && <div className={styles.actions}>{actions}</div>}
            </div>
        </header>
    );
}
